import React from "react";

export default function HeroSection() {
  return (
    <section class="hero">
      <div class="container position-relative z-2">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <h1 class="mb-4 animate-on-scroll">
              Easily Complete Immigration Forms
            </h1>
            <p class="lead mb-5 animate-on-scroll">
              — and connect with Lawyers when needed
              <br />
              Green Card Renewal, Family Petitions, and Citizenship
              Applications
            </p>
            <div class="d-flex flex-wrap justify-content-center gap-3 animate-on-scroll">
              <a
                href="#requestform"
                class="btn btn-primary-custom herosection-buttons"
                aria-label="starttoday"
              >
                Get Started Today
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
